'use strict'
import { shortcutButtons } from './shortcutButtons'

var __assign = function () {
    __assign = Object.assign || function __assign (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i]
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
    }
    return __assign.apply(this, arguments)
}

var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? 'shorthand' : 'longhand'][monthNumber] }

function clearNode (node) {
    while (node.firstChild) { node.removeChild(node.firstChild) }
}
function getEventTarget (event) {
    try {
        if (typeof event.composedPath === 'function') {
            var path = event.composedPath()
            return path[0]
        }
        return event.target
    } catch (error) {
        return event.target
    }
}

var defaultConfig = {
    shorthand: false,
    dateFormat: 'F Y',
    altFormat: 'F Y',
    theme: 'light',
    shortcutButtons: { show: false },
    confirmed: { upperButtonTypes: [] }
}
function monthSelectPlugin (pluginConfig) {
    var config = __assign(__assign({}, defaultConfig), pluginConfig)
    return function (fp) {
        fp.config.dateFormat = config.dateFormat
        fp.config.altFormat = config.altFormat
        fp.config.shortcutButtons = config.shortcutButtons
        fp.config.confirmed = config.confirmed
        fp.config.confirmed.upperButtonTypes = [
            { className: 'btn-one-month-before', text: '1MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth()), fp.config.maxDate], active: false },
            { className: 'btn-three-months-before', text: '3MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth() - 2), fp.config.maxDate], active: false },
            { className: 'btn-six-months-before', text: '6MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth() - 5), fp.config.maxDate], active: false }
        ]
        fp.config.upperButtonTypes = [
            { className: 'btn-one-month-before', text: '1MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth()), fp.config.maxDate], active: false },
            { className: 'btn-three-months-before', text: '3MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth() - 2), fp.config.maxDate], active: false },
            { className: 'btn-six-months-before', text: '6MBefore', date: [new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth() - 5), fp.config.maxDate], active: false }
        ]
        var self = { monthsContainer: null, upperButtonContainer: null, lowerButtonContainer: null }
        const {
            handleLimitMonthRangeToSixMonths,
            handleRemoveActiveLately,
            handleConfirmButton,
            handleClickLatelyMonth
        } = shortcutButtons(fp)
        function clearUnnecessaryDOMElements () {
            if (!fp.rContainer) { return }
            clearNode(fp.rContainer)
            for (var index = 0; index < fp.monthElements.length; index++) {
                var element = fp.monthElements[index]
                if (!element.parentNode) { continue }
                element.parentNode.removeChild(element)
            }
        }
        function build () {
            if (!fp.rContainer) { return }
            self.monthsContainer = fp._createElement('div', 'flatpickr-monthSelect-months')
            self.monthsContainer.tabIndex = -1
            buildMonths()
            fp.rContainer.appendChild(self.monthsContainer)
            fp.calendarContainer.classList.add('flatpickr-monthSelect-theme-' + config.theme)
            if (!fp.config.shortcutButtons.show) {
                return
            }
            if (fp.config.mode === 'range') {
                self.upperButtonContainer = fp._createElement('div', 'flatpickr-upper-buttons')
                self.lowerButtonContainer = fp._createElement('div', 'flatpickr-lower-buttons')
                buildUpperButtons()
                buildLowerButtons()
                fp.calendarContainer.prepend(self.upperButtonContainer)
                fp.calendarContainer.append(self.lowerButtonContainer)
            }
        }
        function buildMonths () {
            if (!self.monthsContainer) { return }
            clearNode(self.monthsContainer)
            var frag = document.createDocumentFragment()
            for (var i = 0; i < 12; i++) {
                var month = fp.createDay('flatpickr-monthSelect-month', new Date(fp.currentYear, i), 0, i)
                if (month.dateObj.getMonth() === new Date().getMonth() &&
                    month.dateObj.getFullYear() === new Date().getFullYear()) { month.classList.add('today') }
                month.textContent = monthToStr(i, config.shorthand, fp.l10n)
                month.addEventListener('click', selectMonth)
                frag.appendChild(month)
            }
            self.monthsContainer.appendChild(frag)
            if (fp.config.minDate &&
                fp.currentYear === fp.config.minDate.getFullYear()) {
                fp.prevMonthNav.classList.add('flatpickr-disabled')
            } else {
                fp.prevMonthNav.classList.remove('flatpickr-disabled')
            }
            if (fp.config.maxDate &&
                fp.currentYear === fp.config.maxDate.getFullYear()) {
                fp.nextMonthNav.classList.add('flatpickr-disabled')
            } else {
                fp.nextMonthNav.classList.remove('flatpickr-disabled')
            }
        }
        function buildUpperButtons () {
            if (fp.config.minDate > new Date(fp.config.maxDate.getFullYear(), fp.config.maxDate.getMonth())) return
            if (!self.upperButtonContainer) { return }
            clearNode(self.upperButtonContainer)
            var frag = document.createDocumentFragment()
            for (let item = 0; item < fp.config.upperButtonTypes.length; item++) {
                if (fp.config.minDate <= fp.config.upperButtonTypes[item].date[0]) {
                    frag.appendChild(getUpperButtonsElements(fp.config.upperButtonTypes[item]))
                }
            }
            self.upperButtonContainer.appendChild(frag)
        }
        function getUpperButtonsElements (btnType) {
            if (fp.selectedDates[0].toString() === btnType.date[0].toString() && fp.selectedDates[1].toString() === btnType.date[1].toString()) btnType.active = true
            const btnEl = fp._createElement('button', `btn-lately-month ${btnType.className} ${btnType.active ? 'active-lately' : ''}`, fp.l10n[btnType.text])
            fp._bind(btnEl, 'click', () => handleClickLatelyMonth(btnEl, btnType))
            return btnEl
        }
        function buildLowerButtons () {
            if (!self.lowerButtonContainer) { return }
            clearNode(self.lowerButtonContainer)
            var frag = document.createDocumentFragment()
            const lowerButtonTypes = [
                { className: 'btn-cancel', text: fp.l10n['cancel'], event: fp.close },
                { className: 'btn-confirm', text: fp.l10n['confirm'], event: handleConfirmButton }
            ]
            for (let item = 0; item < lowerButtonTypes.length; item++) {
                const btnEl = fp._createElement('button', lowerButtonTypes[item].className, lowerButtonTypes[item].text)
                fp._bind(btnEl, 'click', lowerButtonTypes[item].event)
                frag.appendChild(btnEl)
            }
            self.lowerButtonContainer.appendChild(frag)
        }
        function bindEvents () {
            fp._bind(fp.prevMonthNav, 'click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                fp.changeYear(fp.currentYear - 1)
                selectYear()
                buildMonths()
            })
            fp._bind(fp.nextMonthNav, 'click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                fp.changeYear(fp.currentYear + 1)
                selectYear()
                buildMonths()
            })
            fp._bind(self.monthsContainer, 'mouseover', function (e) {
                if (fp.config.mode === 'range') {
                    fp.onMouseOver(getEventTarget(e), 'flatpickr-monthSelect-month')
                }
            })
        }
        function setCurrentlySelected () {
            if (!fp.rContainer) { return }
            if (!fp.selectedDates.length) { return }
            var currentlySelected = fp.rContainer.querySelectorAll('.flatpickr-monthSelect-month.selected')
            for (var index = 0; index < currentlySelected.length; index++) {
                currentlySelected[index].classList.remove('selected')
            }
            var targetMonth = fp.selectedDates[0].getMonth()
            var month = fp.rContainer.querySelector('.flatpickr-monthSelect-month:nth-child(' + (targetMonth + 1) + ')')
            if (month) {
                month.classList.add('selected')
            }
            if (fp.config.mode !== 'range') return
            var btnConfirm = fp.calendarContainer.querySelector('.btn-confirm')
            if (fp.selectedDates.length === 2) {
                btnConfirm.classList.remove('disable')
            } else {
                btnConfirm.classList.add('disable')
            }
            if (fp.selectedDates.length === 1) {
                fp.config.active = ''
                fp.config.upperButtonTypes.forEach(item => { item.active = false })
                handleRemoveActiveLately()
            }
            handleLimitMonthRangeToSixMonths()
        }
        function selectYear () {
            // var selectedDate = fp.selectedDates[0]
            // if (selectedDate) {
            //     selectedDate = new Date(selectedDate)
            //     selectedDate.setFullYear(fp.currentYear)
            //     if (fp.config.minDate && selectedDate < fp.config.minDate) {
            //         selectedDate = fp.config.minDate
            //     }
            //     if (fp.config.maxDate && selectedDate > fp.config.maxDate) {
            //         selectedDate = fp.config.maxDate
            //     }
            //     fp.currentYear = selectedDate.getFullYear()
            // }
            fp.currentYearElement.value = String(fp.currentYear)
            if (fp.rContainer) {
                var months = fp.rContainer.querySelectorAll('.flatpickr-monthSelect-month')
                months.forEach(function (month) {
                    month.dateObj.setFullYear(fp.currentYear)
                    if ((fp.config.minDate && month.dateObj < fp.config.minDate) ||
                        (fp.config.maxDate && month.dateObj > fp.config.maxDate)) {
                        month.classList.add('flatpickr-disabled')
                    } else {
                        month.classList.remove('flatpickr-disabled')
                    }
                })
            }
            setCurrentlySelected()
        }
        function selectMonth (e) {
            e.preventDefault()
            e.stopPropagation()
            var eventTarget = getEventTarget(e)
            if (!(eventTarget instanceof Element)) { return }
            if (eventTarget.classList.contains('flatpickr-disabled')) { return }
            if (eventTarget.classList.contains('notAllowed')) { return } // necessary??
            setMonth(eventTarget.dateObj)
            if (fp.config.closeOnSelect) {
                var single = fp.config.mode === 'single'
                var range = fp.config.mode === 'range' && fp.selectedDates.length === 2
                if (single || range) { fp.close() }
            }
        }
        function setMonth (date) {
            var selectedDate = new Date(fp.currentYear, date.getMonth(), date.getDate())
            var selectedDates = []
            switch (fp.config.mode) {
            case 'single':
                selectedDates = [selectedDate]
                break
            case 'multiple':
                selectedDates.push(selectedDate)
                break
            case 'range':
                if (fp.selectedDates.length === 2) {
                    selectedDates = [selectedDate]
                } else {
                    selectedDates = fp.selectedDates.concat([selectedDate])
                    selectedDates.sort(function (a, b) { return a.getTime() - b.getTime() })
                }
                break
            }
            fp.setDate(selectedDates, true)
            fp.changeYear(date.getFullYear())
            buildMonths()
        }
        var shifts = {
            37: -1,
            39: 1,
            40: 3,
            38: -3
        }
        function onKeyDown (_, __, ___, e) {
            var shouldMove = shifts[e.keyCode] !== undefined
            if (!shouldMove && e.keyCode !== 13) {
                return
            }
            if (!fp.rContainer || !self.monthsContainer) { return }
            var currentlySelected = fp.rContainer.querySelector('.flatpickr-monthSelect-month.selected')
            var index = Array.prototype.indexOf.call(self.monthsContainer.children, document.activeElement)
            if (index === -1) {
                var target = currentlySelected || self.monthsContainer.firstElementChild
                target.focus()
                index = target.$i
            }
            if (shouldMove) {
                self.monthsContainer.children[(12 + index + shifts[e.keyCode]) % 12].focus()
            } else if (e.keyCode === 13 &&
                self.monthsContainer.contains(document.activeElement)) {
                setMonth(new Date(fp.currentYear, 0, 1))
            }
        }
        function closeHook () {
            var _a
            if (((_a = fp.config) === null || _a === void 0 ? void 0 : _a.mode) === 'range' && fp.selectedDates.length === 1) { fp.clear(false) }
            if (!fp.selectedDates.length) {
                buildMonths()
            }
        }
        // Help the prev/next year nav honor config.minDate (see 3fa5a69)
        function stubCurrentMonth () {
            config._stubbedCurrentMonth = fp._initialDate.getMonth()
            fp._initialDate.setMonth(config._stubbedCurrentMonth)
            fp.currentMonth = config._stubbedCurrentMonth
        }
        function unstubCurrentMonth () {
            if (!config._stubbedCurrentMonth) { return }
            fp._initialDate.setMonth(config._stubbedCurrentMonth)
            fp.currentMonth = config._stubbedCurrentMonth
            delete config._stubbedCurrentMonth
        }
        function destroyPluginInstance () {
            if (self.monthsContainer !== null) {
                var months = self.monthsContainer.querySelectorAll('.flatpickr-monthSelect-month')
                for (var index = 0; index < months.length; index++) {
                    months[index].removeEventListener('click', selectMonth)
                }
            }
        }
        return {
            onParseConfig: function () {
                fp.config.enableTime = false
            },
            onValueUpdate: setCurrentlySelected,
            onKeyDown: onKeyDown,
            onReady: [
                stubCurrentMonth,
                clearUnnecessaryDOMElements,
                build,
                buildMonths,
                bindEvents,
                setCurrentlySelected,
                function () {
                    fp.config.onClose.push(closeHook)
                    fp.loadedPlugins.push('monthSelect')
                    if (fp.config.mode !== 'range') return
                    fp.config.confirmed.upperButtonTypes.date = fp.selectedDates
                    fp.currentYear = fp.selectedDates[1].getFullYear()
                    fp.changeYear(fp.currentYear)
                    selectYear()
                }
            ],
            onOpen: [
                buildMonths,
                buildUpperButtons,
                buildLowerButtons,
                function () {
                    fp.config.confirmed.upperButtonTypes.date = fp.selectedDates
                }
            ],
            onClose: [
                function () {
                    fp.changeYear(fp.currentYear)
                    selectYear()
                    if (fp.config.mode !== 'range') return
                    fp.config.upperButtonTypes.forEach((item, idx) => {
                        item.active = fp.config.confirmed.upperButtonTypes[idx].active
                    })
                    fp.config.disable = []
                    fp.setDate(fp.config.confirmed.upperButtonTypes.date, true)
                }
            ],
            onDestroy: [
                unstubCurrentMonth,
                destroyPluginInstance,
                function () {
                    fp.config.onClose = fp.config.onClose.filter(function (hook) { return hook !== closeHook })
                }
            ],
            onChange: [
                buildMonths
            ],
            buildMonths,
            buildUpperButtons,
            buildLowerButtons
        }
    }
}

export default monthSelectPlugin
